import { render, staticRenderFns } from "./SkillsLibraryList.vue?vue&type=template&id=65b85bc2&scoped=true&"
import script from "./SkillsLibraryList.vue?vue&type=script&lang=js&"
export * from "./SkillsLibraryList.vue?vue&type=script&lang=js&"
import style0 from "./SkillsLibraryList.vue?vue&type=style&index=0&id=65b85bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b85bc2",
  null
  
)

export default component.exports